import { TerminalFlight } from 'terminal-flight';
import { SearchProducts } from '@white-label-types/parking-booking';

type AnyResults = TerminalFlight[] | SearchProducts[];

const isSearchProduct = (
  v: SearchProducts | TerminalFlight
): v is SearchProducts => 'productHeader' in v;

const hasNoCapacity = (sp: SearchProducts) => sp.capacity.left === 0;

const sortByDate = (a: SearchProducts, b: SearchProducts) =>
  new Date(a.entry_date).getTime() - new Date(b.entry_date).getTime();

export const timeslotProductFilter = (
  searchResults: AnyResults
): SearchProducts[] => {
  const filtered = searchResults.filter(isSearchProduct);
  if (filtered.every(hasNoCapacity)) return [];
  return filtered.toSorted(sortByDate);
};
